import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { createBrowserRouter, RouterProvider } from 'react-router-dom';
import {
  DialogProvider,
  LanguageProvider,
  QueryProvider,
  SessionBootstrap,
  ThemeProvider,
  ToastProvider,
  TooltipProvider,
  ZohoChatSync,
} from './providers';
import { Toaster } from '@/shared/components/ui/sonner';
import routes from './routing/routes';
import '@/app/styles/index.css';
import '@/app/i18n';

const router = createBrowserRouter(routes);

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <QueryProvider>
      <ToastProvider>
        <TooltipProvider>
          <ThemeProvider />
          <LanguageProvider />
          <SessionBootstrap>
            <RouterProvider router={router} />
          </SessionBootstrap>
          <DialogProvider />
          <Toaster />
          <ZohoChatSync />
        </TooltipProvider>
      </ToastProvider>
    </QueryProvider>
  </StrictMode>
);
